import { css } from '@emotion/react';

import { Size } from './AppStyles';

export const spaceBetween = (amount: Size) => css`
  & > * {
    margin-top: ${amount};
    margin-bottom: 0;

    /*
			Emotion warns about using the :first-child pseudo-selector; when server-side rendering,
			those styles cannot be applied. When a SSR page is then hydrated and the browser _is_
			able to apply styles, the page will jump.

			However, this app does not use SSR so choosing to use a ridiculously long
			ignore token instead;
		*/
    /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
    &:first-child {
      margin-top: initial;
    }
  }
`;
